module.exports = __webpack_public_path__ + "img/dialog-bg.b8bad0a1.png";